import { CounterCustomerChargeEntity } from "domain/entity/CounterCustomerCharge/CounterCustomerChargeEntity";
import { CounterCustomerChargeMaintenanceConstant } from "presentation/constant/CounterCustomerCharge/CounterCustomerChargeMaintenanceConstant";
import { useCounterCustomerChargeMaintenanceVM } from "presentation/hook/CounterCustomerCharge/useCounterCustomerChargeMaintenanceVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useCounterCustomerChargeMaintenanceTracked } from "presentation/store/CounterCustomerCharge/CounterCustomerChargeMaintenanceProvider";
import { HeaderTitle } from "presentation/view/components/HeaderWithBackButton/HeaderTitle";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import { memo, useCallback, useMemo, useState } from "react";
import { FieldType, HPHButton, HPHInputTextarea, IFieldValue, Loader } from "veronica-ui-component/dist/component/core";
import { SidebarActionBar, Sidebarheader } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";

const UpdateInvoiceInfoPanel = () => {
    const [counterCustomerChargeState] = useCounterCustomerChargeMaintenanceTracked();
    const counterCustomerChargeVM = useCounterCustomerChargeMaintenanceVM();
    const COUNTER_CUSTOMER_CHARGE_CONSTANT = CounterCustomerChargeMaintenanceConstant.Detail;
    const { editingEntity } = counterCustomerChargeState;
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const messageBarVM = useMessageBarVM();

    const vaildation = useCallback(() => {
        let hasMT = false;
        let hasH = false;
        let hasI = false;
        let hasMH = false;
        let hasSH = false;
        let hasDI = false;
        let hasSA = false;
        let hasSG = false;
        let hasW = false;

        counterCustomerChargeState.selectedRows.forEach((entity) => {
            if (entity.dtlState === "I") {
                hasI = true;
            } else if (entity.dtlState === "MT") {
                hasMT = true;
            } else if (entity.dtlState === "SH") {
                hasSH = true;
            } else if (entity.dtlState === "MH") {
                hasMH = true;
            } else if (entity.dtlState === "H") {
                hasH = true;
            } else if (entity.dtlState === "DI") {
                hasDI = true;
            } else if (entity.dtlState === "SA") {
                hasSA = true;
            } else if (entity.dtlState === "SG") {
                hasSG = true;
            } else if (entity.dtlState === "W") {
                hasW = true;
            }
        })

        if (hasH || hasI || hasMH || hasMT || hasSH || hasDI || hasSA || hasSG || hasW) {
            messageBarVM.showError("Just allow update Invoice Info. for R/F/E/T and waiver approved charge.");
            return false;
        }
        return true;
    }, [messageBarVM, counterCustomerChargeState.selectedRows]);

    const handleSaveClick = useCallback(async () => {
        if (!vaildation()) {
            return;
        }
        setIsLoading(true);
        let entityList: CounterCustomerChargeEntity[] = [];
        counterCustomerChargeState.selectedRows.forEach(item => {
            item.invoiceRemarks = editingEntity?.invoiceRemarks;
            item.exciseCashNo = editingEntity?.exciseCashNo;
            entityList.push(item);
        });
        counterCustomerChargeVM.onSave(entityList).then((res) => {
            if (res && res.success) {
                messageBarVM.showSuccess('Save Successfully.');
                counterCustomerChargeVM.onMoreClose();
                counterCustomerChargeVM.onSearchCounterCustomer(counterCustomerChargeState.searchCriteria);
            } else {
                messageBarVM.showError('Save Failed.');
            }
            setIsLoading(false);
        });
    }, [counterCustomerChargeVM, counterCustomerChargeState.selectedRows, counterCustomerChargeState.searchCriteria, messageBarVM, editingEntity, vaildation]);

    const handClose = useCallback(() => {
        counterCustomerChargeVM.onMoreClose();
    }, [counterCustomerChargeVM]);

    const memoExciseCashNo = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "220px", marginBottom: "24px", marginLeft: "15px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={true}
                readOnlyValue={editingEntity?.exciseCashNo || ''}
                fieldValue={editingEntity?.exciseCashNo}
                fieldLabel={COUNTER_CUSTOMER_CHARGE_CONSTANT.EXCISE_CASH_NO}
                isSaveClicked={false}
                fieldType={FieldType.TEXT}
                fieldKey={'exciseCashNo'}
                maxLength={60}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    counterCustomerChargeVM.onCounterCustomerFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [COUNTER_CUSTOMER_CHARGE_CONSTANT.EXCISE_CASH_NO, editingEntity?.exciseCashNo, counterCustomerChargeVM])

    const memoRemarks = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "325px", marginBottom: "24px", marginLeft: "15px" }}>
            <HPHInputTextarea
                label={COUNTER_CUSTOMER_CHARGE_CONSTANT.REMARKS}
                width="325px"
                rows={3}
                resizable={false}
                helpIcon={true}
                value={editingEntity.invoiceRemarks?.toString()}
                onChange={(e) => { counterCustomerChargeVM.onTextAreaChangeCC(e, "invoiceRemarks", true) }} />
        </div>
        , [editingEntity.invoiceRemarks, counterCustomerChargeVM, COUNTER_CUSTOMER_CHARGE_CONSTANT.REMARKS])


    return (<div className='side-form-content-left-wrapper' style={{ padding: "20px 20px 20px 0px" }}>
        <div className={'flex-row'}>
            <div className={'flex-row-item flex-row-item-full-width'}>
                <Sidebarheader>
                    <HeaderTitle>{"Update Invoice Info"}</HeaderTitle>
                </Sidebarheader>
            </div>
        </div>

        {isLoading && <Loader Indicator="Spinner" size="Medium" />}

        <div className={'add-edit-form'} style={{ maxHeight: '75vh', height: '75vh', overflow: 'auto' }}>
            <div className="flex-row-auto">
                <div className={'flex-row-item'}>
                    {memoExciseCashNo}
                    {memoRemarks}
                </div>
            </div>
        </div>
        <SidebarActionBar>
            <HPHButton label={'Close'} size={'Small'} theme={'Secondary'} onClick={handClose} />
            <HPHButton label={'Save'} size={'Small'} theme={'Primary'} onClick={() => handleSaveClick()} />
        </SidebarActionBar>
    </div>)
}

export default memo(UpdateInvoiceInfoPanel);